<script>
    import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
</script>

<!--https://lottiefiles.com/mervinin-->
<!--for some reason this one isn't working even in REPL-->
<!-- <LottiePlayer src="https://assets8.lottiefiles.com/packages/lf20_XfjRNN.json" background="transparent" speed="1" style="width: 300px; height: 300px;" loop="{true}" autoplay /> -->
<div class="spinner">
    <LottiePlayer src="https://assets1.lottiefiles.com/packages/lf20_jllppvk7.json" background="transparent" renderer="svg" speed={1} width={200} height={200} autoplay={true} loop={true} controls={false} controlsLayout={[]} />
</div>